import {FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {ViewCashVo} from '../../common/shared/api/nicolas/vo/billing/ViewCashVo.interface';
import {postStoreViewCash} from '../store/postStoreViewCash';

type ViewCashResponse = ViewCashVo & ApiResultVo;

export async function getAccountCash(
  options?: FetcherOptions
): Promise<ViewCashResponse> {
  return postStoreViewCash(options);
}
